module.exports = "/img/_/_/_/assets/images/creeper/book/common//41.jpg?914285f14127bbbff468c80c33511564";